import {useEffect, useState} from 'react';

const LOG_PREFIX = '[useEntityPersonnel]';
const BASE = (process.env.REACT_APP_AWP_API_BASE || process.env.REACT_APP_AWP_API_URL || '')
    .replace(/\/$/, '');

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {Authorization: `Bearer ${token}`} : {};
}

/**
 * Analysts/collectors who interacted with a KB entity (reports, CMs, ICR/EEI/CT, Notes).
 *
 * @param {string} entityId
 * @param {number} [refetchKey=0]
 * @returns {{personnel: Array, loading: boolean, error: Error|null}}
 */
export function useEntityPersonnel(entityId, refetchKey = 0) {
    const [personnel, setPersonnel] = useState([]);
    const [loading, setLoading] = useState(!!entityId);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!entityId) {
            setPersonnel([]);
            setLoading(false);
            setError(null);
            return undefined;
        }

        let cancelled = false;
        setLoading(true);
        setError(null);

        fetch(`${BASE}/api/entities/${encodeURIComponent(entityId)}/personnel`, {
            headers: authHeaders(),
        })
            .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`${r.status}`))))
            .then((data) => {
                if (cancelled) return;
                const list = Array.isArray(data?.personnel)
                    ? data.personnel
                    : (Array.isArray(data) ? data : []);
                setPersonnel(list);
                setLoading(false);
            })
            .catch((err) => {
                if (cancelled) return;
                console.error(`${LOG_PREFIX} Error:`, err);
                setError(err);
                setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [entityId, refetchKey]);

    return {personnel, loading, error};
}

export default useEntityPersonnel;
